<template>

    <div class="container-center">

        <el-card class="box-card">

            <div slot="header" class="clearfix contract-data-top with-icon">
                <img
                    src="data:image/png;base64,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">
                <p><span class="title">{{ detailData.pricingName || '核价申请发起' }}</span></p>
                <p class="status">
                    <span :title="detailData.approveStatus" v-bind:class="['state-shet'+ detailData.approveStatus]">
                        {{ baseStatus[detailData.approveStatus] }}
                        {{ detailData.nodeName && (`（当前审批节点：${detailData.nodeName}）`) }}
                    </span>
                </p>
                <br><span v-if="detailData.oaRequestId">流程ID：{{ detailData.oaRequestId }}</span> &nbsp;&nbsp;&nbsp;&nbsp;
                <!-- <br>所属合同：{{ decodeURIComponent($route.params.name) }} &nbsp;&nbsp;&nbsp;&nbsp; <span v-if="pageType!=0">发起时间：{{ detailData.createDate }}</span> -->
            </div>


            <!-- 材料列表 -->
            <table class="el-table el-table--striped el-table--border mian-table">
                <tr>
                    <td class="table-head">发包单位</td>
                    <td class="table-content">{{ contractInfo.firstPacName || contractInfo.ownerParty }}</td>
                    <td class="table-head">项目名称</td>
                    <td class="table-content">{{ contractInfo.projectname }}</td>
                </tr>
                <tr>
                    <td class="table-head">合同名称</td>
                    <td class="table-content">{{ contractInfo.fname }}</td>
                    <td class="table-head">核价单编号</td>
                    <td class="table-content">{{ (pageType!=0 && detailData.pricingNo) || '无' }}</td>
                </tr>
                <tr>
                    <td class="table-head">合同编号</td>
                    <td class="table-content">{{ contractInfo.contractBillId }}</td>
                    <td class="table-head">供方名称</td>
                    <td class="table-content">
                        {{ contractInfo.supplierName }}
                    </td>
                </tr>
            </table>

            <!-- 添加材料 -->
            <div
                v-if="pageType==0 || detailData.approveStatus == 0 || detailData.approveStatus == 5"
                class="text-right" style="padding: 5px 0;float:right;">
                <el-button @click="addMeterialDialog = true;resetForm();" type="primary" size="mini">添加材料</el-button>
            </div>

            <el-table :data="detailData.dhsConPricingDetailList||[]" size="mini" border>
                <el-table-column align="center" width="60" type="index" label="序号"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip width="160" label="材料名称" prop="materialNameInfo"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip width="150" label="材料规格" prop="materialNorm"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip width="150" label="材料品牌" prop="materialBrand"></el-table-column>
                <el-table-column align="center" min-width="80" label="材料数量" prop="materialAmount"></el-table-column>
                <el-table-column align="center" min-width="80" label="申报单价（含税）" prop="taxPrice"></el-table-column>
                <el-table-column align="center" min-width="80" label="申报单价（除税）" prop="notaxPrice"></el-table-column>
                <el-table-column align="center" min-width="80" label="备注" prop="remarks"></el-table-column>
                <el-table-column align="center" v-if="detailData.approveStatus==3"  min-width="80" label="核定单价（除税）" prop="comNotaxPrice"></el-table-column>
                <el-table-column align="center" v-if="detailData.approveStatus==3"  min-width="80" label="核定小计（除税）" prop="rowNum"></el-table-column>
                <el-table-column align="center" v-if="detailData.approveStatus==3" show-overflow-tooltip width="100" label="核价说明" prop="cbRemark"></el-table-column>
                <el-table-column align="center" width="120" label="操作">
                    <template slot-scope="scope">
                        <a v-if="scope.row.id" @click="getMeterial(scope.row.id)">查看</a>
                        <a v-if="detailData.approveStatus!=2 && detailData.approveStatus!=3 && detailData.approveStatus!=4"
                        @click="setMeterial(scope.row.id)">编辑</a>
                        <a v-if="detailData.approveStatus!=2 && detailData.approveStatus!=3 && detailData.approveStatus!=4"
                        @click="delMeterial(scope.row.id)">删除</a>
                    </template>
                </el-table-column>
            </el-table>

            <div class="text-center" style="padding:30px 0;">
                <el-button @click="$router.push($root.navs[1].path)" type="" size="medium" icon="el-icon-back">返回合同台账
                </el-button>
                <el-button
                    v-if="pageType==0 || detailData.approveStatus == 0 || detailData.approveStatus == 5"
                    @click="submitMeterial" type="primary" size="medium">提交申请
                </el-button>
            </div>


            <!-- 分隔线 -->
            <div v-if="pageType!=0" class="fade-line"></div>
            <!-- 审批记录 -->
            <div v-if="pageType!=0">
                <label class="fade-title">审批记录</label>

                <el-table :data="detailData.approveList||[]" size="mini" border stripe>
                    <el-table-column align="center" width="50" type="index" label="序号"></el-table-column>
                    <el-table-column align="center" width="160" label="发起时间" prop="createDate"></el-table-column>
                    <el-table-column align="center" width="160" label="审批结果" prop="approveStatus">
                        <template slot-scope="scope">
                            <span v-bind:class="'state-shet'+scope.row.approveStatus" :title="scope.row.approveStatus">
                                {{ baseStatus[scope.row.approveStatus] }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="审批意见" prop="approveRemark"></el-table-column>
                    <el-table-column align="center" width="160" label="审批时间" prop="approveDate"></el-table-column>
                </el-table>
            </div>

        </el-card>


        <!-- 添加、编辑 材料 -->
        <el-dialog :title="(setMeterialMode ? '修改' : '添加') +'材料信息'" :visible.sync="addMeterialDialog" width="800px"
                   @close="resetForm" center>

            <el-form label-width="160px" ref="form" :model="form" :rules="rules" size="mini">
                <div class="remark">
                    <span>友情提示：</span>如当前材料设备名称及施工项名称不能满足核价申请填报需要，请通过以下方式申请新增名称：
                </div>
                <div class="remark">
                    1、 加入QQ业务咨询群“外部单位外网使用”，群号882437923，加入时根据“单位名称-问题简述”，注明“单位简称”及“新增材料名称”。加入后@新增材料名称管理员，提出新增需求；
                </div>
                <div class="remark">
                    2、 联系我司 “新增材料名称管理员”谈琴 QQ号383735112，电话021-66340070-324。
                </div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="材料名称：" prop="materialName">


                            <el-cascader
                                :options="allMaterialTree"
                                :props="props"
                                filterable
                                placeholder="支持模糊搜索"
                                @change="handleChange">
                            </el-cascader>
                            <!--     {{form.materialName}}
                                 <el-select v-model="form.materialName" filterable style="width:100%;">
                                     <el-option v-for="li in allMaterial" :label="li.fnameL2" :value="li.fid"
                                                :key="li.fid"></el-option>
                                 </el-select>-->


                        </el-form-item>
                        <el-form-item label="材料品牌：" prop="">
                            <el-input v-model="form.materialBrand" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="申报单价（含税）：" prop="taxPrice">
                            <el-input v-model="form.taxPrice" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="供应商：" prop="">
                            <el-input v-model="form.supplierName" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="联系人：" prop="">
                            <el-input v-model="form.linkperson" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="Email：" prop="">
                            <el-input v-model="form.email" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="材料规格：" prop="materialNorm">
                            <el-input v-model="form.materialNorm" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="是否甲供材料：" prop="">
                            <el-select placeholder="请选择" v-model="form.isJgcl">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                        </el-select>
                        </el-form-item>
                        <el-form-item label="数量：" prop="">
                            <el-col :span="14">
                                <el-input v-model="form.materialAmount" clearable></el-input>
                            </el-col>
                            <el-col :span="9" :offset="1">
                                <el-select v-model="form.unit" placeholder="单位">
                                    <el-option v-for="o in allUnit" :label="o.fnameL2" :value="o.fid"
                                               :key="o.fid"></el-option>
                                </el-select>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="申报单价（除税）：" prop="notaxPrice">
                            <el-input v-model="form.notaxPrice" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="单位地址：" prop="">
                            <el-input v-model="form.address" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话：" prop="">
                            <el-input v-model="form.tel" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-form-item label="附件：" prop="">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        multiple
                        :limit="20"
                        :action="uploadApi"
                        :file-list="form.baseFileList"
                        :on-success="handleAdd" :on-error="uploadError"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemove"
                    >
                        <el-button size="small" type="primary">上 传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="addMeterialDialog = false">取 消</el-button>
                <el-button type="primary" @click="setMeterial_" v-if="setMeterialMode">修 改</el-button>
                <el-button type="primary" @click="addMeterial" v-else>保 存</el-button>
            </span>

        </el-dialog>


        <!-- 查看材料 -->
        <el-dialog title="材料信息" :visible.sync="meterialDataDialog" width="720px" @close="resetForm" center>

            <div class="detail-dialog">
                <el-row>
                    <el-col :span="5" class="text-right">材料名称：</el-col>
                    <el-col :span="7">{{ allMaterials['no'+ form.materialName] || '无' }}</el-col>
                    <el-col :span="5" class="text-right">材料规格：</el-col>
                    <el-col :span="7">{{ form.materialNorm || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">材料品牌：</el-col>
                    <el-col :span="7">{{ form.materialBrand || '无' }}</el-col>
                    <el-col :span="5" class="text-right">是否甲供材料：</el-col>
                    <el-col :span="7">{{ form.isJgcl=="1"?'是':'否' }}</el-col>
                    <el-col :span="5" class="text-right">数量：</el-col>
                    <el-col :span="7">{{ form.materialAmount || '无' }} {{ allUnits['no'+ form.unit] }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">申报单价（含税）：</el-col>
                    <el-col :span="7">{{ form.taxPrice || '无' }}</el-col>
                    <el-col :span="5" class="text-right">申报单价（除税）：</el-col>
                    <el-col :span="7">{{ form.notaxPrice || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">供应商：</el-col>
                    <el-col :span="7">{{ form.supplierName || '无' }}</el-col>
                    <el-col :span="5" class="text-right">单位地址：</el-col>
                    <el-col :span="7">{{ form.address || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">联系人：</el-col>
                    <el-col :span="7">{{ form.linkperson || '无' }}</el-col>
                    <el-col :span="5" class="text-right">联系电话：</el-col>
                    <el-col :span="7">{{ form.tel || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">Email：</el-col>
                    <el-col :span="7">{{ form.email || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">附件：</el-col>
                    <el-col :span="19">
                        <div v-if="!form.baseFileList || form.baseFileList && form.baseFileList.length==0"
                             class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in form.baseFileList" :key="li.id"><a :href="downloadApi +'?fileId='+ li.id"
                                                                                target="_blank">{{ li.fileOldName }}</a>
                            </li>
                        </ul>
                    </el-col>
                </el-row>
            </div>


        </el-dialog>


    </div><!-- container-center -->

</template>

<script type="text/babel">
    import banner from '@/assets/imgs/banner_inviteMng.png'
    import util from '@/util'

    export default {
        name: 'contract-detail',
        data () {
            return {

                props: {
                    value: 'fid',
                    children: 'dhsConMatMaterialTypeList',
                    label: 'fnameL2',
                    disabled: 'noCanShow'
                },

                allMaterialTree: [],

                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadApi: `${util.baseUrl}rest/file/down`,

                baseStatus: ['草稿', '待审批', '审批中', '已审批', '审批不通过', '打回'],

                allMaterial: [],
                allMaterials: {},
                allUnit: [],
                allUnits: {},

                // 表单验证
                rules: {
                    materialName: [
                        {required: true, message: '必填'}
                    ],
                    materialNorm: [
                        {required: true, message: '必填'}
                    ],
                    isJgcl:[
                        {required: true, message: '必填'}
                    ],
                    taxPrice: [
                        {required: true, message: '必填'},
                        { pattern: /^[0-9]+(\.[0-9]{0,2})?$/ ,message:'只能输入大于0的最多两位小数', trigger:'blur'}
                    ],
                    // materialAmount: [
                    //     {type: 'number', message: '数字'}
                    // ],
                    notaxPrice: [
                        {required: true, message: '必填'},
                        { pattern: /^[0-9]+(\.[0-9]{0,2})?$/ ,message:'只能输入大于0的最多两位小数', trigger:'blur'}
                    ]
                },

                // 页面类型 0: 发起,带billId;  1: 查看,带msgId
                pageType: this.$route.params.type,

                // 发起后返回的 ID
                createId: '',

                // 详情数据
                detailData: {
                    dhsConPricingDetailList: []
                },

                // 添加材料
                addMeterialDialog: false,
                form: {
                    materialName: '',
                    materialBrand: '',
                    taxPrice: '',
                    supplierName: '',
                    linkperson: '',
                    email: '',
                    materialNorm: '',          
                    materialAmount: '',
                    unit: '',
                    notaxPrice: '',
                    address: '',
                    tel: '',
                    isJgcl: '',
                    baseFileList: []
                },
                setMeterialMode: false,
                setMeterialId: '',

                // 已有材料信息
                meterialDataDialog: false,
                contractInfo: {},
            }
        },
        methods: {
            handleChange (value) {
                this.form.materialName = value[value.length - 1]
                if (!this.allMaterials['no'+ this.form.materialName]) {
                    // 如果没有材料
                    this.form.materialName = ''
                    this.$message({type: 'error', message: '选择的可能是材料结构并非材料，请重新选择'})
                }
            },

            // 上传文件格式验证
            beforeUpload (file) {
                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'})
                    return false
                }

                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },

            uploadError () {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'})
            },

            // 配置信息
            getAllMaterial () {
                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})
                this.$http.post('rest/api/contract/getAllMaterialTree', {}).then((res) => {
                    loading.close()

                    if (res.data.result) {
                        this.allMaterialTree = res.data.value
                    } else {
                        this.$message({message: 'Error: 材料名称获取失败', type: 'error'})
                    }
                })
                this.$http.post('rest/api/contract/getAllMaterial', {}).then((res) => {
                    loading.close()

                    if (res.data.result) {
                        this.allMaterial = res.data.value
                        this.allMaterial.forEach((data, index) => {
                            this.allMaterials['no' + data.fid] = data.fnameL2
                        })
                    } else {
                        this.$message({message: 'Error: 材料名称获取失败', type: 'error'})
                    }
                })
            },
            getAllUnit () {
                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})
                this.$http.post('rest/api/contract/getAllUnit', {}).then((res) => {
                    loading.close()

                    if (res.data.result) {
                        this.allUnit = res.data.value

                        this.allUnit.forEach((data, index) => {
                            this.allUnits['no' + data.fid] = data.fnameL2
                        })
                    } else {
                        this.$message({message: 'Error: 单位获取失败', type: 'error'})
                    }
                })
            },

            // pageType: 0 发起
            createPricing () {
                this.$http.post('rest/api/contract/createPricing', {
                    contractBillId: this.$route.params.id
                }).then((res) => {
                    if (res.data.result) {
                        // this.$message({message: '请添加材料', type: 'success'})

                        this.createId = res.data.value.id
                        this.contractInfo = res.data.value.conContractBill

                        this.$root.navs = [{
                            name: '合同业务列表',
                            path: '/contractList'
                        }, {
                            name: decodeURIComponent(this.$route.params.name),
                            path: '/contractSheet/' + encodeURIComponent(this.$route.params.id)
                        }, {name: '发起'}]
                    } else {
                        this.$message({message: 'Error: 发起', type: 'error'})
                    }
                })
            },

            // pageType: 0|1 获取详情
            getDetailData () {
                const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                this.$http.post('rest/api/contract/PricingInfo', {
                    msgId: this.$route.params.id
                }).then((res) => {
                    loading.close()
                    if (res.data.result) {
                        this.detailData = res.data.value
                        this.contractInfo = res.data.value.conContractBill

                        if (this.detailData.approveStatus==3) {
                            // 获得计算是数据
                            let tempOne = {
                                materialNameInfo: '合计',
                                
                            }
                            let totalCount = 0
                            let totalPrice = 0
                            this.detailData.dhsConPricingDetailList.forEach(temp => {
                                totalCount += Number(temp.materialAmount)
                                temp.rowNum = Number(Number(temp.comNotaxPrice).toFixed(2)) * Number(temp.materialAmount)

                                totalPrice += Number(temp.rowNum)
                            })

                            tempOne.materialAmount = totalCount
                            tempOne.rowNum = totalPrice
                            this.detailData.dhsConPricingDetailList.push(tempOne)
                        }

                        this.$root.navs = [{
                            name: '合同业务列表',
                            path: '/contractList'
                        }, {
                            name: decodeURIComponent(this.$route.params.name),
                            path: '/contractSheet/' + encodeURIComponent(this.detailData.contractBillId)
                        }, {name: '详情'}]
                    } else {
                        this.$message({message: 'Error: 获取详情', type: 'error'})
                    }
                })
            },

            resetForm () {
                this.form = {
                    materialName: '',
                    materialBrand: '',
                    taxPrice: '',
                    supplierName: '',
                    linkperson: '',
                    email: '',
                    materialNorm: '',
                    materialAmount: '',
                    unit: '',
                    notaxPrice: '',
                    address: '',
                    tel: '',
                    isJgcl: '',
                    baseFileList: []
                }
                this.setMeterialMode = false

                this.$refs['form'] && this.$refs['form'].clearValidate()

                this.allUnit[0] && (this.form.unit = this.allUnit[0].fid)
            },

            handleRemove: function (file, fileList) {
                // this.form.baseFileList = this.form.baseFileList.filter(function (f) {
                //     return f.uid !== file.uid
                // })
            },
            handleAdd: function (response, file, fileList) {
                // if(file.status=='success'){
                // this.form.baseFileList = __getBaseFiles__(file, fileList)
                // }
            },

            // pageType: 0|1 添加材料
            addMeterial () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if (isNaN(+this.form.materialAmount)) {
                            this.$message({message: '数量请输入数字', type: 'error'})
                            return
                        }

                        const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})
                        this.form.baseFileList = __getBaseFiles__(null, this.$refs.upload.uploadFiles)

                        this.$http.post('rest/api/contract/createPricingDetail',
                            Object.assign(
                                {
                                    contractBillId: (this.$route.params.type == 0 ? this.$route.params.id : this.detailData.contractBillId),
                                    pricingId: (this.$route.params.type == 0 ? this.createId : this.$route.params.id)
                                },
                                this.form
                            )
                        ).then((res) => {
                            // loading.close()
                            this.addMeterialDialog = false

                            if (res.data.result) {
                                this.$message({message: '材料添加成功', type: 'success'})

                                if (this.pageType == 0) {  // 初次发起跳往详情
                                    this.$router.push('/ContractDetail00/1/' + this.createId + '/' + encodeURIComponent(this.$route.params.name))
                                    setTimeout(function () {
                                        location.reload()
                                    }, 1000)
                                } else {
                                    this.getDetailData()  // 获取最新信息
                                }
                            } else {
                                this.$message({message: 'Error: 材料添加失败', type: 'error'})
                            }
                        })
                    } else {
                        this.$message({message: '材料表单填写有误', type: 'error'})
                        return false
                    }
                })
            },

            // 查看材料
            getMeterial (id) {
                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})
                this.$http.post('rest/api/contract/getPricingDetailInfo', {
                    msgId: id
                }).then((res) => {
                    loading.close()

                    if (res.data.result) {
                        this.form = res.data.value
                        this.meterialDataDialog = true
                    } else {
                        this.$message({message: 'Error: 材料信息获取失败', type: 'error'})
                    }
                })
            },

            // 显示修改表单
            setMeterial (id) {
                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})
                this.$http.post('rest/api/contract/getPricingDetailInfo', {
                    msgId: id
                }).then((res) => {
                    loading.close()

                    if (res.data.result) {
                        this.form = res.data.value

                        this.form.baseFileList.forEach(function (data) {
                            data.name = data.fileOldName
                        })

                        this.setMeterialMode = true
                        this.setMeterialId = id

                        this.addMeterialDialog = true
                    } else {
                        this.$message({message: 'Error: 材料信息获取失败', type: 'error'})
                    }
                })
            },

            // 真正修改请求
            setMeterial_ () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if (isNaN(+this.form.materialAmount)) {
                            this.$message({message: '数量请输入数字', type: 'error'})
                            return
                        }

                        const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})
                        this.form.baseFileList = __getBaseFiles__(null, this.$refs.upload.uploadFiles)
                        this.$http.post('rest/api/contract/updatePricingDetail',
                            Object.assign(
                                {
                                    contractBillId: this.detailData.contractBillId,
                                    pricingId: this.$route.params.id,
                                    id: this.setMeterialId
                                },
                                this.form
                            )
                        ).then((res) => {
                            loading.close()
                            this.addMeterialDialog = false

                            if (res.data.result) {
                                this.$message({message: '材料修改成功', type: 'success'})

                                this.getDetailData()  // 获取最新列表
                            } else {
                                this.$message({message: 'Error: 材料修改失败', type: 'error'})
                            }
                        })
                    } else {
                        this.$message({message: '材料表单填写有误', type: 'error'})
                        return false
                    }
                })
            },

            delMeterial (id) {
                this.$confirm('确定要删除材料吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                    this.$http.post('rest/api/contract/deletePricingDetail', {
                        msgId: id
                    }).then((res) => {
                        loading.close()

                        if (res.data.result) {
                            this.$message({message: '删除成功', type: 'success'})
                            this.getDetailData()  // 获取最新列表
                        } else {
                            this.$message({message: '删除失败：' + res.data.message, type: 'error'})
                        }
                    })
                })
            },

            // 提交申请
            submitMeterial () {
                if (this.detailData.dhsConPricingDetailList.length == 0) {
                    this.$message({message: '请先添加材料', type: 'error'})
                    return
                }

                const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                this.$http.post('rest/api/contract/postPricing', {
                    id: this.$route.params.id,
                    contractBillId: this.detailData.contractBillId
                }).then((res) => {
                    loading.close()

                    if (res.data.result) {
                        this.$message({message: '提交成功', type: 'success'})
                        setTimeout(function () {
                            location.reload()
                        }, 1000)
                    } else {
                        this.$message({message: '提交失败：' + res.data.message, type: 'error'})
                    }
                })
            }
        },
        created () {
            this.$root.headImage.src = banner
            this.$root.activeIndex = 'home'
            this.$root.isPublic = false
            this.$root.navs = []
        },
        mounted () {
            // dev test

            // 获取配置信息
            this.getAllMaterial()
            this.getAllUnit()

            // 0: 发起 带billId;  1: 查看 带msgId 2:重新发起
            if (this.pageType == 0) {
                this.createPricing()
            } else {
                this.getDetailData()
            }

            util.toTop()
        }
    }

    function __getBaseFiles__ (file, fileList) {
        let fs = []
        fileList.forEach(function (item) {
            console.log(item)
            if (item.response) {
                let f = item.response.basefiles[0]
                item.bizTableName = f.biztablename
                item.bizTablePkName = f.biztablepkname
                item.bizTablePkValue = f.biztablepkvalue
                item.fid = f.fid
                item.fileCatagoryId = f.filecatagoryid
                item.fileDesc = f.filedesc
                item.fileOldName = f.fileoldname
                item.name = f.fileoldname
                item.fileName = f.filename
                item.filePath = f.filepath
                item.fileSize = f.filesize
                item.fileType = f.filetype
                item.sort = f.sort
            }
            fs.push(item)
        })
        console.log(fs)
        return fs
    }
</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';

    .remark{
        font-size: 12px;
        color: #999;
    }
    .remark span{
        color:red;
    }

    a {
        color: var(--cMain);
        cursor: pointer;
    }

    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }

    .box-card {
        margin: 30px 0;
    }


    .fade-title {
        display: inline-block;
        margin-bottom: 20px;
        color: var(--cTxt2);
        font-size: 15px;
        font-weight: bold;
        line-height: 28px;
    }

    .fade-line {
        border-top: 1px dashed #ddd;
        margin: 40px 0;
    }


    .detail-dialog {
        padding: 20px 0;
    }

    .detail-dialog .el-row {
        line-height: 32px;
    }

    .detail-dialog .text-right {
        color: var(--cTxt3);
    }


</style>



// WEBPACK FOOTER //
// src/pages/dsp/contract/vDetail00.vue